import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "page-add" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "btn-group" }
const _hoisted_4 = { class: "section" }
const _hoisted_5 = { class: "section" }
const _hoisted_6 = { class: "form-item" }
const _hoisted_7 = { class: "section" }
const _hoisted_8 = { class: "form-item" }
const _hoisted_9 = { class: "section" }
const _hoisted_10 = { class: "form-item" }
const _hoisted_11 = { class: "btn-group" }

import { ref, reactive, computed } from 'vue'
import { useRouter } from "vue-router";
import * as options from '@/utils/options';
import { ElMessage, ElMessageBox } from 'element-plus'
import { checkUserExist, createCustomer } from '@/api'

interface Manager {
  name: string,
  mail: string,
  phone: string
}
interface TaxInfo {
  taxInfoType: string,
  taxInfoDetail: string[]
}
interface CustomerForm {
  user: {
    userId: string,
    companyName: string
  },
  manager: Manager[],
  taxInfo: TaxInfo | null,
  meno: string
}

type InputRef = {
  focus: () => void;
  value?: string | number;
};



export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerAdd',
  setup(__props) {

const router = useRouter();
// const toBoard = () => router.push("/");
const toBack = () => {
  if (window.history.length > 1) {
    router.back();
  } else {
    router.push('/');
  }
}
const mailType = ref<string>(null);
const mailDetail = ref<string>(null);

const form = reactive<CustomerForm>({
  user: {
    userId: '',
    companyName: ''
  },
  manager: [
    {
      name: '',
      mail: '',
      phone: ''
    }
  ],
  taxInfo: {
    taxInfoType: '',
    taxInfoDetail: []
  }
})

const mailTypePlaceholder = computed(() => {
  if (!mailType.value) return '발행 방식 선택'
  return mailType.value === 'EMAIL' ? '이메일(쉽표로 구분)' : '시스템';
})

const handleSearchAccount = async () => {
  if (form.user.userId.length < 1 ) {
    ElMessageBox.alert('검색어를 입력해주세요.', { confirmButtonText: '확인' });
    return
  }

  const params = {
    userId: form.user.userId
  }

  try {
    const response = await checkUserExist(params);
    if (response.success && response.result) {
      form.user.companyName = response.result.userName
    } else {
      ElMessageBox.alert('존재하지 않는 계정입니다.', { confirmButtonText: '확인' });
    }
  } catch (error) {
    if (error.message === 'Customer exist') {
      ElMessageBox.alert('이미 등록된 계정입니다.', { confirmButtonText: '확인' });
    } else {
      ElMessageBox.alert('서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.<br/> 문제가 지속되면 관리자에게 문의하세요.', { 
        confirmButtonText: '확인',
        dangerouslyUseHTMLString: true
      });
    }
  }
}

const mainManagerNum = ref<number>(0)

const companyInputRef = ref<InputRef>(null)
const managerNameRef = ref<InputRef>(null)
const mailsInsertRef = ref<InputRef>(null)


const handleAddManager = () => {
  form.manager.push({
    name: '',
    mail: '',
    phone: '',
  })
}

const handleRemoveManager = (index) => {
  form.manager.splice(index, 1);
}

const setMainManager = (index) => {
  [form.manager[0], form.manager[index]] = [form.manager[index], form.manager[0]]
}

const handleSubmit = async () => {
  if (!validateFormData()) return
  const params = form

  params.manager.map(manager => {
    manager.phone = manager.phone.replace(/-/g, "")
    return manager
  })

  if (!mailType.value) {
    params.taxInfo = null;
  } else {
    params.taxInfo.taxInfoType = mailType.value;
    params.taxInfo.taxInfoDetail = mailDetail.value.split(',').filter(t => t !== '').map(t => t.trim());
    
    if (params.taxInfo.taxInfoType === 'EMAIL' && !params.taxInfo.taxInfoDetail.every(mail => isEmailText(mail))) {
      return showAlertAndFocus('유효하지 않은 이메일이 포함되어있습니다.', mailsInsertRef.value);
    }
    if (params.taxInfo.taxInfoType === 'SYSTEM' && params.taxInfo.taxInfoDetail.some(mail => isEmailText(mail))) {
      return showAlertAndFocus('시스템명이 이메일 형식으로 되어 있습니다.', mailsInsertRef.value);
    }
  } 
  
  // if (mailDetail.value) {
  //   params.taxInfo.taxInfoDetail = mailDetail.value.split(',').filter(t => t !== '').map(t => t.trim())
  // }

  try {
    const response = await createCustomer(params);
    console.log('고객 정보를 생성 성공:', response);
    ElMessageBox.alert('고객 정보를 생성했습니다. 고객 관리 목록으로 이동합니다.', {
      confirmButtonText: '확인',
      callback: () => {
        router.push({name: 'CustomerManage'});
      },
    });
  } catch (error) {
    console.error('Error Message:', error)
    ElMessage.error('고객 정보를 생성에 실패했습니다. 다시 시도해주세요')
  }
}

const validateFormData = () => {

  if (!form.user.companyName) return showAlertAndFocus('회사명을 입력해주세요.', companyInputRef.value);
  if (form.manager.length === 1 && !form.manager[0].name ) return showAlertAndFocus('담당자를 입력해주세요.', managerNameRef.value);
  const checkManager = form.manager.every(item => {
    return item.name && item.mail
  })
  if (!checkManager) return showAlertAndFocus('담당자 이름, 이메일은 필수 입력입니다.', managerNameRef.value);
  if (mailType.value && !mailDetail.value) return showAlertAndFocus('서류 발행 이메일을 입력하세요.', mailsInsertRef.value);
  return true
}

const isEmailText = (mail) => {
  const regEmail = /^[!#$%&'*+\-/=?^_`{|}~.a-zA-Z0-9-]+@[\w.-]+\.[A-Za-z0-9-]+$/;
  return regEmail.test(mail);
};


const showAlertAndFocus = (message: string, inputRef: InputRef | undefined) => {
  ElMessageBox.alert(message, { confirmButtonText: '확인' });
  if (inputRef && inputRef.focus) inputRef.focus();
  return false;
};


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "tit-h2" }, " 고객 추가 ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: "primary",
          size: "large",
          "aria-label": "이전으로",
          class: "btn-icon",
          onClick: toBack
        }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-arrow-left-long" })
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_el_form, {
      model: form,
      "label-position": "left",
      "label-width": "100px",
      class: "content-box"
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_4, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "section-header" }, [
            _createElementVNode("h3", { class: "tit-h3" }, " 기본 정보 "),
            _createElementVNode("div", { class: "description" }, " 뷰저블 계정이 없어도 추가할 수 있으며, 회사명은 필수입니다. ")
          ], -1)),
          _createVNode(_component_el_form_item, { label: "뷰저블 계정" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.user.userId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.user.userId) = $event)),
                size: "large",
                style: {"width":"300px"},
                onKeyup: _withKeys(handleSearchAccount, ["enter"])
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    "aria-label": "검색",
                    onClick: handleSearchAccount
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-magnifying-glass" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "회사명",
            props: "companyName",
            rules: [
            { required: true, message: '회사명은 필수값입니다.' },
          ]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.user.companyName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.user.companyName) = $event)),
                size: "large",
                style: {"width":"300px"},
                ref_key: "companyInputRef",
                ref: companyInputRef
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("section", _hoisted_5, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "section-header" }, [
            _createElementVNode("h3", { class: "tit-h3" }, " 담당자 정보 "),
            _createElementVNode("div", { class: "description" }, " 최소 1명의 이름과 이메일은 필수입니다. 별도 이메일 계정이 없는 경우, 뷰저블 계정을 기재해주세요. ")
          ], -1)),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.manager, (manager, i) => {
              return (_openBlock(), _createBlock(_component_el_row, {
                class: "document-row",
                key: `manager-${i}`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, {
                    span: 2,
                    align: "center"
                  }, {
                    default: _withCtx(() => [
                      (i > 0)
                        ? (_openBlock(), _createBlock(_component_el_tooltip, {
                            key: 0,
                            content: "대표로 지정",
                            placement: "top"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                icon: "",
                                circle: "",
                                size: "small",
                                onClick: ($event: any) => (setMainManager(i))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-crown" })
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createBlock(_component_el_button, {
                            key: 1,
                            text: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_text, { tag: "b" }, {
                                default: _withCtx(() => _cache[8] || (_cache[8] = [
                                  _createTextVNode(" 대표 ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_col, { span: 4 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: manager.name,
                        "onUpdate:modelValue": ($event: any) => ((manager.name) = $event),
                        size: "large",
                        placeholder: "이름(필수)",
                        ref_for: true,
                        ref_key: "managerNameRef",
                        ref: managerNameRef
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: manager.mail,
                        "onUpdate:modelValue": ($event: any) => ((manager.mail) = $event),
                        size: "large",
                        placeholder: "이메일(필수)"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: manager.phone,
                        "onUpdate:modelValue": ($event: any) => ((manager.phone) = $event),
                        size: "large",
                        placeholder: "핸드폰 번호(번호만 입력)"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024),
                  (i>0)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "primary",
                        text: "",
                        "aria-label": "삭제",
                        onClick: ($event: any) => (handleRemoveManager(i))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "fa-regular fa-trash-can" })
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _createVNode(_component_el_button, {
              type: "primary",
              plain: "",
              onClick: handleAddManager
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { class: "el-icon--left" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-plus" })
                  ]),
                  _: 1
                }),
                _cache[9] || (_cache[9] = _createTextVNode(" 추가 "))
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("section", _hoisted_7, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "section-header" }, [
            _createElementVNode("h3", { class: "tit-h3" }, " 세금 계산서 발행 정보 "),
            _createElementVNode("div", { class: "description" }, " 결제 방식이 무통장인 경우에만 입력해주세요. ")
          ], -1)),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_el_row, { class: "document-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 4 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: mailType.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((mailType).value = $event)),
                      placeholder: "발행 방식 선택",
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.optionsTaxInfoType, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 15 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: mailDetail.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((mailDetail).value = $event)),
                      size: "large",
                      placeholder: mailTypePlaceholder.value,
                      disabled: !mailType.value,
                      ref_key: "mailsInsertRef",
                      ref: mailsInsertRef
                    }, null, 8, ["modelValue", "placeholder", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("section", _hoisted_9, [
          _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "tit-h3" }, " 메모 ", -1)),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_input, {
              modelValue: form.memo,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.memo) = $event)),
              rows: 5,
              type: "textarea",
              placeholder: "입력하세요"
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_el_button, {
        type: "primary",
        size: "large",
        onClick: handleSubmit
      }, {
        default: _withCtx(() => _cache[13] || (_cache[13] = [
          _createTextVNode(" 저장 ")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "default",
        size: "large",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(router).back()))
      }, {
        default: _withCtx(() => _cache[14] || (_cache[14] = [
          _createTextVNode(" 취소 ")
        ])),
        _: 1
      })
    ])
  ]))
}
}

})